export default "__VITE_ASSET__5tOPbL4K__"